/** Base URL for every API call. '/api' is proxied to the API by the Vite dev server. */
export const API_BASE_URL: string = import.meta.env.VITE_API_URL || '/api'

/** True when the email-only dev login is enabled for this build. */
export const DEV_LOGIN_ENABLED: boolean = import.meta.env.VITE_AUTH_DEV_LOGIN === 'true'
